import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const WASTE = [
  { value: "konyhai", label: "Konyhai maradék" },
  { value: "kerti", label: "Kerti zöld" },
  { value: "mindketto", label: "Mindkettő" },
];
const AMOUNT = [
  { value: "zsak_1", label: "Kb. 1 zsák" },
  { value: "zsak_2_5", label: "2–5 zsák" },
  { value: "zsak_5plusz", label: "5+ zsák" },
  { value: "rendszeres", label: "Rendszeresen gyűjtenék" },
];

export default function PickupFormGB() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", address: "", waste_type: "mindketto", amount: "zsak_1", message: "", privacy_consent: false });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error("Add meg a neved");
    if (!form.phone.trim() && !form.email.trim()) return toast.error("Adj meg telefonszámot vagy emailt");
    if (form.address.trim().length < 3) return toast.error("Add meg a címet vagy a környéket");
    if (!form.privacy_consent) return toast.error("Fogadd el az adatkezelési tájékoztatót");
    setLoading(true);
    try {
      await api.post("/pickup-requests", { ...form, email: form.email.trim() || null, phone: form.phone.trim() || null, message: form.message.trim() || null });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Hiba történt. Próbáld újra.");
    } finally { setLoading(false); }
  };

  if (done) {
    return (
      <div className="form-card" data-testid="pickup-success">
        <p className="eyebrow">Megkaptuk</p>
        <h3 className="h-md" style={{ marginBottom: 16 }}>Látjuk a kérésed.</h3>
        <p className="muted">Köszönjük, hogy külön gyűjtesz. Hamarosan jelentkezünk a megadott elérhetőségen, és egyeztetjük az elszállítást.</p>
      </div>
    );
  }

  return (
    <form className="form-card" onSubmit={submit} noValidate data-testid="pickup-form">
      <div className="field">
        <label className="field-label" htmlFor="pk-name">Név</label>
        <input id="pk-name" className="input-gb" value={form.name} onChange={(e) => update("name", e.target.value)} placeholder="Hogy szólíthatunk?" data-testid="pickup-name-input" />
      </div>
      <div className="field">
        <label className="field-label" htmlFor="pk-phone">Telefonszám <span className="opt">vagy email alább</span></label>
        <input id="pk-phone" className="input-gb" type="tel" value={form.phone} onChange={(e) => update("phone", e.target.value)} placeholder="+36 …" data-testid="pickup-phone-input" />
      </div>
      <div className="field">
        <label className="field-label" htmlFor="pk-email">Email <span className="opt">opcionális</span></label>
        <input id="pk-email" className="input-gb" type="email" value={form.email} onChange={(e) => update("email", e.target.value)} placeholder="te@pelda.hu" data-testid="pickup-email-input" />
      </div>
      <div className="field">
        <label className="field-label" htmlFor="pk-address">Cím vagy környék</label>
        <input id="pk-address" className="input-gb" value={form.address} onChange={(e) => update("address", e.target.value)} placeholder="XVII. kerület, utca…" data-testid="pickup-address-input" />
      </div>
      <fieldset className="choices" style={{ marginBottom: 20 }}>
        <legend>Mit gyűjtesz?</legend>
        {WASTE.map((o) => (
          <label className="choice" key={o.value}>
            <input type="radio" name="waste_type" value={o.value} checked={form.waste_type === o.value} onChange={() => update("waste_type", o.value)} data-testid={`pickup-waste-${o.value}`} />
            <span>{o.label}</span>
          </label>
        ))}
      </fieldset>
      <fieldset className="choices" style={{ marginBottom: 20 }}>
        <legend>Mennyiség</legend>
        {AMOUNT.map((o) => (
          <label className="choice" key={o.value}>
            <input type="radio" name="amount" value={o.value} checked={form.amount === o.value} onChange={() => update("amount", o.value)} data-testid={`pickup-amount-${o.value}`} />
            <span>{o.label}</span>
          </label>
        ))}
      </fieldset>
      <div className="field">
        <label className="field-label" htmlFor="pk-msg">Üzenet <span className="opt">opcionális</span></label>
        <textarea id="pk-msg" className="input-gb" value={form.message} onChange={(e) => update("message", e.target.value)} placeholder="Mikor érsz rá? Hol találjuk a zsákot?" data-testid="pickup-message-input" />
      </div>
      <label className="check-gb">
        <input type="checkbox" checked={form.privacy_consent} onChange={(e) => update("privacy_consent", e.target.checked)} data-testid="pickup-privacy-checkbox" />
        <span>Elfogadom az adatkezelési tájékoztatót. Az adataidat csak az elszállítás egyeztetésére használjuk.</span>
      </label>
      <button type="submit" className="btn btn-primary btn-block" disabled={loading} data-testid="pickup-submit-button">
        {loading ? "Küldés…" : <>Írok nektek <span className="arrow">→</span></>}
      </button>
    </form>
  );
}
